// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @30.07.2019 15:08:14
import * as SagaBase from '../../SagaBase';
import { Guid, GuidTools } from '@models/guid';
import { BaseObject } from '@models/BaseObject';

export abstract class RouteResult_abstract extends BaseObject {
  static $t: string = 'SagaBase.RouteResult';
  $t: string = 'SagaBase.RouteResult';

  public static GetMembers(): string[] {
    return ['Points', 'ProjCode', 'Distance', 'DistanceUnit', 'Time', 'Culture', 'ElementId', 'Error'];
  }

  public GetMembers(): string[] {
    return RouteResult_abstract.GetMembers();
  }

  public _init(): void {
    //// Add "NO-" before "AUTO_INIT_CODE" if don't want to re-generate at each compilation
    ///*<AUTO_INIT_CODE>*/
    ///*</AUTO_INIT_CODE>*/
  }

  // Add "NO-" before "INSTANCE_MEMBERS" if don't want to re-generate at each compilation
  /*<INSTANCE_MEMBERS>*/

  public Points: any[];
  public ProjCode: string;
  public Distance: number;
  public DistanceUnit: SagaBase.RouteDistanceUnit;
  public Time: any;
  public Culture: string;
  public ElementId: Guid = GuidTools.Empty;
  public Error: string;

  /*</INSTANCE_MEMBERS>*/

  // Add "NO-" before "AUTO_IMPLEMENTATION" if don't want to re-generate at each compilation
  /*<AUTO_IMPLEMENTATION>*/

  /*</AUTO_IMPLEMENTATION>*/
}
